import ModalDelete from "components/ModalCustom/ModalDelete"
import LabelNotificationPage from "components/Notification/LabelNotificationPage"
import { useBoolean } from "helpers/hooks"
import {
  checkPermissionPage,
  handleCheckUpdateFileComponent,
  messageAndURLRemoveFileComponent,
} from "helpers/utils"
import React, { useContext, useEffect, useState } from "react"
import { toast } from "react-toastify"
import { STATUS_RESPONSE } from "types"
import { STATUS_TYPE_FILE_BUILD } from "../build-history.constant"
import { PermissionProjectComponentPage } from "../contexts/PermissionProjectComponentPage.context"
import UpdateFileItem from "../molecules/UpdateFileItem"
import { deleteFilePCBTemplateMiddleware } from "../services"
import { InfoFileDetail, ExtendedViewType, FileUrlProp } from "../types"
import FormSubComponentBOM from "./FormSubComponentBOM"
import AttachmentOtherCard from "./AttachmentOtherCard"
import { RootState } from "stores/configureStore"
import {
  downloadQueueManager,
  UploadFileType,
} from "components/DownloadProcess/downloadQueue"
import { useDispatch, useSelector } from "react-redux"
import { resetUpload, startUpload } from "reducers/upload-file"
import { chain, isUndefined, pickBy } from "lodash"
import { PERMISSIONS } from "constants/permissions"

interface Props {
  idComponentHistory: string
  handleUpdateDataPCB: (idComponentHistory: string, type?: string) => void
  infoFileGerber: InfoFileDetail
  infoFileBOM: InfoFileDetail
  infoFileStackup: InfoFileDetail
  infoFileAssembly: InfoFileDetail
  listFileUrl: FileUrlProp[]
  detailViewType: ExtendedViewType
  setDetailViewType: (type: ExtendedViewType) => void
  handleUpdateBomFile?: (idHistory: string) => void
  handleDeleteAttachment: (fileId: string) => void
  isDeleted?: boolean
  projectBuildId: string
  projectId: string
  componentCode: string
  duplicateFileNames: string[]
}
const isEqualProps = (prevProps: Props, nextProps: Props) => {
  return (
    prevProps.idComponentHistory === nextProps.idComponentHistory &&
    prevProps.infoFileGerber === nextProps.infoFileGerber &&
    prevProps.infoFileBOM === nextProps.infoFileBOM &&
    prevProps.infoFileStackup === nextProps.infoFileStackup &&
    prevProps.infoFileAssembly === nextProps.infoFileAssembly &&
    prevProps.detailViewType === nextProps.detailViewType &&
    prevProps.isDeleted === nextProps.isDeleted &&
    prevProps.listFileUrl === nextProps.listFileUrl &&
    JSON.stringify(prevProps.duplicateFileNames) === JSON.stringify(nextProps.duplicateFileNames)
  )
}

const UpdateFileBuildCard = React.memo((props: Props) => {
  const {
    idComponentHistory,
    infoFileAssembly,
    infoFileBOM,
    infoFileGerber,
    infoFileStackup,
    listFileUrl,
    handleUpdateDataPCB,
    detailViewType,
    setDetailViewType,
    handleUpdateBomFile,
    handleDeleteAttachment,
    isDeleted,
    componentCode,
    projectBuildId,
    projectId,
    duplicateFileNames,
  } = props
  const {
    archiveProject,
    viewOnlyShare,
    archiveComponent,
    archiveBuild,
    isNoUpdateFilePCB,
  } = useContext(PermissionProjectComponentPage)

  const isLoading = useBoolean(false)
  const isDelete = useBoolean(false)
  const isFormSubComponent = useBoolean(false)
  const [typeFile, setTypeFile] = useState({
    status: "",
    urlDelete: "",
    messageSuccess: "",
    messageError: "",
  })
  const dispatch = useDispatch()
  const uploadFileGerberId = `${idComponentHistory}-${UploadFileType.GERBER}`
  const uploadFilePCBBomId = `${idComponentHistory}-${UploadFileType.PCB_BOM}`
  const uploadFilePCBStackupId = `${idComponentHistory}-${UploadFileType.PCB_STACKUP}`
  const uploadFilePCBAssemblyId = `${idComponentHistory}-${UploadFileType.PCB_ASSEMBLY}`
  const baseAttachmentId = `${idComponentHistory}-${UploadFileType.PCB_ATTACHMENT}`

  const storeUploadStatus = useSelector(
    (state: RootState) => state.upload.status
  )
  const statusByComponentHistory = pickBy(storeUploadStatus, (_, key) =>
    key.startsWith(idComponentHistory)
  )


  const uploadGerber = statusByComponentHistory[uploadFileGerberId]
  const uploadPCBBOM = statusByComponentHistory[uploadFilePCBBomId]
  const uploadPCBStackup = statusByComponentHistory[uploadFilePCBStackupId]
  const uploadPCBAssembly = statusByComponentHistory[uploadFilePCBAssemblyId]

  const uploadAttachments = chain(statusByComponentHistory)
    .pickBy((_, key) => key.startsWith(baseAttachmentId))
    .toPairs()
    .map(([key, value]) => ({
      name: key,
      value: value,
    }))
    .value()

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (uploadGerber) {
        handleUpdateDataPCB(idComponentHistory)
        dispatch(resetUpload(uploadFileGerberId))
        setDetailViewType(ExtendedViewType.Gerber)
      }
      if (uploadPCBBOM) {
        if (handleUpdateBomFile) {
          handleUpdateBomFile(idComponentHistory)
        }
        handleUpdateDataPCB(idComponentHistory)
        dispatch(resetUpload(uploadFilePCBBomId))
        setDetailViewType(ExtendedViewType.Bom)
      }
      if (uploadPCBStackup) {
        handleUpdateDataPCB(idComponentHistory)
        dispatch(resetUpload(uploadFilePCBStackupId))
      }
      if (uploadPCBAssembly) {
        handleUpdateDataPCB(idComponentHistory)
        dispatch(resetUpload(uploadFilePCBAssemblyId))
      }
    }, 1000)
    return () => clearTimeout(timeout)
  }, [uploadGerber, uploadPCBBOM, uploadPCBStackup, uploadPCBAssembly])

  useEffect(() => {
    const timeout = setTimeout(() => {
      const uploadFileAttachmentDone = uploadAttachments.filter(
        (el) => el.value
      )
      if (uploadFileAttachmentDone.length) {
        uploadFileAttachmentDone.forEach((el) => {
          dispatch(resetUpload(el.name))
        })
        handleUpdateDataPCB(idComponentHistory)
      }
    }, 1000)
    return () => clearTimeout(timeout)
  }, [JSON.stringify(uploadAttachments)])

  const handleUpdateFileGerber = (newFile: FormData) => {
    const fileName = Object(newFile.get("file"))?.name
    if (
      handleCheckUpdateFileComponent(
        idComponentHistory,
        fileName,
        "rar,zip,7z"
      )
    ) {
      return
    }
    if (!isUndefined(uploadGerber)) {
      toast(
        <LabelNotificationPage
          messenger="The upload is in progress. Please wait until it is finished."
          type="warning"
        />
      )
      return
    }
    if (duplicateFileNames.includes(fileName)) {
      toast(
        <LabelNotificationPage
          messenger={`File ${fileName} already exists.`}
          type="error"
        />
      )
      return
    }
    dispatch(startUpload(uploadFileGerberId))
    downloadQueueManager.add({
      apiURL: "",
      downloadId: uploadFileGerberId,
      name: fileName,
      subName: `Component: ${componentCode}`,
      dataUploading: {
        file: newFile.get("file"),
        idComponentHistory,
        type: UploadFileType.GERBER,
        projectId,
        componentType: "pcb/gerber",
      },
    })
  }

  const handleUpdateFileBom = async (newFile: FormData) => {
    const fileName = Object(newFile.get("file"))?.name
    if (
      handleCheckUpdateFileComponent(
        idComponentHistory,
        fileName,
        "csv,xls,xlsx",
        "csv|xls|xlsx"
      )
    ) {
      return
    }
    if (!isUndefined(uploadPCBBOM)) {
      toast(
        <LabelNotificationPage
          messenger="The upload is in progress. Please wait until it is finished."
          type="warning"
        />
      )
      return
    }
    if (duplicateFileNames.includes(fileName)) {
      toast(
        <LabelNotificationPage
          messenger={`File ${fileName} already exists.`}
          type="error"
        />
      )
      return
    }
    dispatch(startUpload(uploadFilePCBBomId))
    downloadQueueManager.add({
      apiURL: "",
      downloadId: uploadFilePCBBomId,
      name: fileName,
      subName: `Component: ${componentCode}`,
      dataUploading: {
        file: newFile.get("file"),
        idComponentHistory,
        type: UploadFileType.PCB_BOM,
        projectId,
        componentType: "pcb/bom",
      },
    })
  }
  const handleUpdateFileStackup = (newFile: FormData) => {
    const fileName = Object(newFile.get("file"))?.name
    if (
      handleCheckUpdateFileComponent(
        idComponentHistory,
        fileName,
        "pdf,png,jpg,jpeg",
        "pdf|png|jpg|jpeg"
      )
    ) {
      return
    }

    if (!isUndefined(uploadPCBStackup)) {
      toast(
        <LabelNotificationPage
          messenger="The upload is in progress. Please wait until it is finished."
          type="warning"
        />
      )
      return
    }
    if (duplicateFileNames.includes(fileName)) {
      toast(
        <LabelNotificationPage
          messenger={`File ${fileName} already exists.`}
          type="error"
        />
      )
      return
    }
    dispatch(startUpload(uploadFilePCBStackupId))
    downloadQueueManager.add({
      apiURL: "",
      downloadId: uploadFilePCBStackupId,
      name: fileName,
      subName: `Component: ${componentCode}`,
      dataUploading: {
        file: newFile.get("file"),
        idComponentHistory,
        type: UploadFileType.PCB_STACKUP,
        projectId,
        componentType: "pcb/stackup",
      },
    })
  }

  const handleUpdateFileAssembly = (newFile: FormData) => {
    const fileName = Object(newFile.get("file"))?.name
    if (
      handleCheckUpdateFileComponent(
        idComponentHistory,
        fileName,
        ".exe,.bin,.bat",
        "exe|bin|bat",
        true
      )
    ) {
      return
    }

    if (!isUndefined(uploadPCBAssembly)) {
      toast(
        <LabelNotificationPage
          messenger="The upload is in progress. Please wait until it is finished."
          type="warning"
        />
      )
      return
    }
    if (duplicateFileNames.includes(fileName)) {
      toast(
        <LabelNotificationPage
          messenger={`File ${fileName} already exists.`}
          type="error"
        />
      )
      return
    }
    dispatch(startUpload(uploadFilePCBAssemblyId))
    downloadQueueManager.add({
      apiURL: "",
      downloadId: uploadFilePCBAssemblyId,
      name: Object(newFile.get("file"))?.name,
      subName: `Component: ${componentCode}`,
      dataUploading: {
        file: newFile.get("file"),
        idComponentHistory,
        type: UploadFileType.PCB_ASSEMBLY,
        projectId,
        componentType: "pcb/assembly",
      },
    })
  }
  const handleAddAttachments = (fileRequest: FormData, _fileErrors: File[]) => {
    if (uploadAttachments.length) {
      toast(
        <LabelNotificationPage
          messenger="The upload is in progress. Please wait until it is finished."
          type="warning"
        />
      )
      return
    }
    const files = fileRequest.getAll("files")
    if (files.length === 0) {
      toast(
        <LabelNotificationPage
          messenger="Please choose file to upload!"
          type="error"
        />
      )
      return
    }

    const fileList = Array.from(files).filter(
      (file): file is File => file instanceof File
    )
    downloadQueueManager.add({
      apiURL: "",
      downloadId: baseAttachmentId,
      name: "Attachment",
      subName: `Component: ${componentCode}`,
      dataUploading: {
        fileList: fileList,
        idComponentHistory,
        type: UploadFileType.PCB_ATTACHMENT,
        projectId,
        componentType: "pcb/attachments",
      },
    })
  }

  const getFileNameAndType = (type: STATUS_TYPE_FILE_BUILD) => {
    let result = {
      pcbType: "gerber",
      fileName: infoFileGerber.name,
    }
    switch (type) {
      case STATUS_TYPE_FILE_BUILD.ASSEMBLY:
        result = {
          pcbType: "assembly",
          fileName: infoFileAssembly.name,
        }
        break
      case STATUS_TYPE_FILE_BUILD.STACKUP:
        result = {
          pcbType: "stackup",
          fileName: infoFileStackup.name,
        }
        break
      case STATUS_TYPE_FILE_BUILD.BOM:
        result = {
          pcbType: "bom",
          fileName: infoFileBOM.name,
        }
        break

      default:
        result = {
          pcbType: "gerber",
          fileName: infoFileGerber.name,
        }
        break
    }
    return result
  }
  const onRemoveFile = (type: STATUS_TYPE_FILE_BUILD) => {
    const { messageError, messageSuccess, urlDelete } =
      messageAndURLRemoveFileComponent(type)
    setTypeFile({
      status: type,
      messageSuccess,
      messageError,
      urlDelete,
    })
    isDelete.setValue(true)
  }
  const onSubmitDeleteFile = () => {
    if (!idComponentHistory) {
      return
    }
    const { pcbType, fileName } = getFileNameAndType(typeFile.status as any)
    isLoading.setValue(true)
    deleteFilePCBTemplateMiddleware(
      idComponentHistory,
      typeFile.urlDelete,
      (type: STATUS_RESPONSE, messenger: string) => {
        if (type === STATUS_RESPONSE.SUCCESS) {
          handleUpdateDataPCB(idComponentHistory, typeFile.status)
          if (handleUpdateBomFile) {
            handleUpdateBomFile(idComponentHistory)
          }
          isDelete.setValue(false)
        }
        isLoading.setValue(false)
        const newMessenger =
          type === STATUS_RESPONSE.SUCCESS
            ? typeFile.messageSuccess
            : typeFile.messageError
        toast(
          <LabelNotificationPage
            messenger={messenger ? messenger : newMessenger}
            type={type}
          />
        )
      },
      fileName,
      pcbType
    )
  }

  const renderModal = () => {
    return (
      <React.Fragment>
        {isDelete.value && (
          <ModalDelete
            onCloseModal={() => isDelete.setValue(false)}
            title={`Are you sure to delete file ${typeFile.status}?`}
            label={`Confirmation`}
            onSubmit={onSubmitDeleteFile}
            titleButton="Delete"
          />
        )}
        {isFormSubComponent.value ? (
          <FormSubComponentBOM
            openModal={isFormSubComponent.value}
            onCloseModal={() => isFormSubComponent.setValue(false)}
            idHitory={idComponentHistory}
            nameBOM={infoFileBOM.name}
          />
        ) : null}
      </React.Fragment>
    )
  }

  return (
    <div>
      <div className="grid grid-cols-box-4-min-324 md:grid-cols-4 gap-2 mr-6 mt-6 pb-2 md:pb-0 overflow-x-auto min-h-[138px]">
        <UpdateFileItem
          title={STATUS_TYPE_FILE_BUILD.GERBER}
          handleUpdateFile={handleUpdateFileGerber}
          containerFiles={`container-files-${STATUS_TYPE_FILE_BUILD.GERBER}`}
          file={infoFileGerber.file}
          fileName={infoFileGerber.name}
          onRemoveFile={() => onRemoveFile(STATUS_TYPE_FILE_BUILD.GERBER)}
          isAction={checkPermissionPage(
            PERMISSIONS.PROJECT_COMPONENT_HISTORY_PCB_UPLOAD_GERBER,
            {
              project: archiveProject,
              viewShare: viewOnlyShare,
              component: archiveComponent,
              noUpdateFilePCB: isNoUpdateFilePCB,
              build: archiveBuild,
            }
          )}
          acceptFile=".rar,.zip,.7z"
          detailViewType={detailViewType}
          setDetailViewType={setDetailViewType}
          isDeleted={isDeleted}
          versionId={idComponentHistory}
          projectBuildId={projectBuildId}
          projectId={projectId}
          subNameDownload={`Component: ${componentCode}`}
        />
        <UpdateFileItem
          title={STATUS_TYPE_FILE_BUILD.BOM}
          handleUpdateFile={handleUpdateFileBom}
          containerFiles={`container-files-${STATUS_TYPE_FILE_BUILD.BOM}`}
          file={infoFileBOM.file}
          fileName={infoFileBOM.name}
          onRemoveFile={() => onRemoveFile(STATUS_TYPE_FILE_BUILD.BOM)}
          isAction={checkPermissionPage(
            PERMISSIONS.PROJECT_COMPONENT_HISTORY_PCB_UPLOAD_BOM,
            {
              project: archiveProject,
              viewShare: viewOnlyShare,
              component: archiveComponent,
              noUpdateFilePCB: isNoUpdateFilePCB,
              build: archiveBuild,
            }
          )}
          acceptFile=".csv,.xls,.xlsx"
          detailViewType={detailViewType}
          setDetailViewType={setDetailViewType}
          isDeleted={isDeleted}
          versionId={idComponentHistory}
          projectBuildId={projectBuildId}
          projectId={projectId}
          subNameDownload={`Component: ${componentCode}`}
        />
        <UpdateFileItem
          title={STATUS_TYPE_FILE_BUILD.STACKUP}
          handleUpdateFile={handleUpdateFileStackup}
          containerFiles={`container-files-${STATUS_TYPE_FILE_BUILD.STACKUP}`}
          file={infoFileStackup.file}
          fileName={infoFileStackup.name}
          onRemoveFile={() => onRemoveFile(STATUS_TYPE_FILE_BUILD.STACKUP)}
          isAction={checkPermissionPage(
            PERMISSIONS.PROJECT_COMPONENT_HISTORY_PCB_UPLOAD_STACKUP,
            {
              project: archiveProject,
              viewShare: viewOnlyShare,
              component: archiveComponent,
              noUpdateFilePCB: isNoUpdateFilePCB,
              build: archiveBuild,
            }
          )}
          acceptFile=".pdf,.png,.jpg,.jpeg"
          isDeleted={isDeleted}
          versionId={idComponentHistory}
          projectBuildId={projectBuildId}
          projectId={projectId}
          subNameDownload={`Component: ${componentCode}`}
        />
        <UpdateFileItem
          title={STATUS_TYPE_FILE_BUILD.ASSEMBLY}
          handleUpdateFile={handleUpdateFileAssembly}
          containerFiles={`container-files-${STATUS_TYPE_FILE_BUILD.ASSEMBLY}`}
          file={infoFileAssembly.file}
          fileName={infoFileAssembly.name}
          onRemoveFile={() => onRemoveFile(STATUS_TYPE_FILE_BUILD.ASSEMBLY)}
          isAction={checkPermissionPage(
            PERMISSIONS.PROJECT_COMPONENT_HISTORY_PCB_UPLOAD_ASSEMBLY,
            {
              project: archiveProject,
              viewShare: viewOnlyShare,
              component: archiveComponent,
              noUpdateFilePCB: isNoUpdateFilePCB,
              build: archiveBuild,
            }
          )}
          acceptFile="*"
          isDeleted={isDeleted}
          versionId={idComponentHistory}
          projectBuildId={projectBuildId}
          projectId={projectId}
          subNameDownload={`Component: ${componentCode}`}
        />
        {renderModal()}
      </div>
      <AttachmentOtherCard
        listFileUrl={listFileUrl}
        viewOnly={checkPermissionPage(
          PERMISSIONS.PROJECT_COMPONENT_HISTORY_PCB_UPLOAD_ATTACHMENT,
          {
            project: archiveProject,
            viewShare: viewOnlyShare,
            component: archiveComponent,
            noUpdateFilePCB: isNoUpdateFilePCB,
            build: archiveBuild,
          }
        )}
        typeOther={"pcb"}
        handleUpdateDataWhenDeleteFile={handleDeleteAttachment}
        handleUpdateDataWhenAddFile={handleAddAttachments}
        isDeleted={isDeleted}
        versionId={idComponentHistory}
        projectBuildId={projectBuildId}
        projectId={projectId}
        subNameDownload={`Component: ${componentCode}`}
        duplicateFileNames={duplicateFileNames}
      />
    </div>
  )
}, isEqualProps)
export default UpdateFileBuildCard
